/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Report_Bug_DescriptionInputs */



/**
* | output |
* | --- |
* | "We'll get back to you (we actually will)" |
*
* @param {Layout_Header_Report_Bug_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_report_bug_description = /** @type {((inputs?: Layout_Header_Report_Bug_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Report_Bug_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wir melden uns zurück (wirklich)")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous vous répondrons (vraiment)")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("我们会回复你（真的会）")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("我們會回覆你（真的會）")
	if (locale === "ko") return /** @type {LocalizedString} */ ("꼭 답변드립니다(정말입니다)")
	return /** @type {LocalizedString} */ ("We'll get back to you (we actually will)")
});